export const supportedLanguages = ["it", "en"]

/**
 * Labels that are not just the tag in capitals.
 *
 * Kept, though nothing uses it at present: Ukrainian was offered as "UA"
 * rather than "UK", and if it or any other language whose tag and label differ
 * is offered again, this is where that belongs.
 */
const languageLabels: Record<string, string> = {uk: "UA"}

/**
 * The label to draw on `language`'s switcher pill.
 *
 * @param language one of `supportedLanguages`
 */
export function languageLabel(language: string): string {
    return languageLabels[language] || language.toUpperCase()
}

/**
 * Whether `language` is the one i18next has currently resolved.
 *
 * Compares the base tag rather than the whole string. `i18n.language` is
 * whatever LanguageDetector found, and the detector is configured with neither
 * `load: "languageOnly"` nor `supportedLngs` — so on a fresh profile it is the
 * browser's full region tag ("en-US"), which never equals a bare "en". Content
 * still rendered in English via `fallbackLng`, but every language pill drew
 * inactive with `aria-pressed={false}`, so screen readers announced no selected
 * language until the user clicked one manually.
 *
 * @param current `i18n.language`
 * @param language one of `supportedLanguages`
 */
export function isActiveLanguage(current: string | undefined, language: string): boolean {
    if (!current) {
        return false
    }

    return current === language || current.split("-")[0].toLowerCase() === language
}
